module.exports = __webpack_public_path__ + "img/keine kamishirasawa_sc2.34998b3b.png";